export default __webpack_public_path__ + "static/media/330_portfolio04-nl-web.1032cc59.png";